import ApiBase from "../api-base";

class MembershipsApi extends ApiBase {
    async getMemberships() {
        const response = await this.get(`/memberships`);

        return response.data;
    }

    async getMembership(id) {
        const response = await this.get(`/memberships/${id}`);

        return response.data;
    }
}

export default new MembershipsApi();